import { useState } from 'react';
import EsriDailyReport from './EsriDailyReport';
import TicketReport from './TicketReport';
import NoResponseReport from './NoResponseReport';
import LinearFootageReport from './LinearFootageReport';

// One "Reports" window for the 811 Ticket Finder: pick the kind of report, then run it.
const TYPES = [
  { key: 'esri-daily', label: 'Daily Esri completions', hint: 'Tickets marked PROGRESS = COMPLETE in Esri, and who did them (PM1)', Component: EsriDailyReport },
  { key: 'billing', label: 'Billing (city completions)', hint: "Tickets the city answered in WA 811 in a date range, with weekly volume", Component: TicketReport },
  { key: 'footage', label: 'Linear footage', hint: 'Completed corridor footage (CALC_LENGTH) on linear — not drop — tickets, for per-foot billing', Component: LinearFootageReport },
  { key: 'no-response', label: 'No response', hint: 'Tickets not yet responded to — in Esri, by the city, or both', Component: NoResponseReport },
];
const STORE_KEY = 'ticketFinder.reportType';

function initialType() {
  try {
    const saved = localStorage.getItem(STORE_KEY);
    if (TYPES.some((t) => t.key === saved)) return saved;
  } catch { /* storage blocked — use the default */ }
  return TYPES[0].key;
}

export default function ReportsModal({ onClose }) {
  const [type, setType] = useState(initialType);
  const current = TYPES.find((t) => t.key === type);
  const { Component } = current;

  function pick(key) {
    setType(key);
    try { localStorage.setItem(STORE_KEY, key); } catch { /* ignore */ }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={onClose}>
      <div
        className="border rounded-lg w-full max-w-6xl h-[92vh] flex flex-col"
        style={{ backgroundColor: '#0d1b2e', borderColor: '#1e3a5f' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-5 pb-0 gap-4">
          <div className="min-w-0">
            <h2 className="text-lg font-black text-white tracking-widest uppercase">811 Reports</h2>
            <div className="flex flex-wrap rounded overflow-hidden border mt-3 w-fit" style={{ borderColor: '#1e3a5f' }} role="tablist" aria-label="Report type">
              {TYPES.map((t) => (
                <button
                  key={t.key}
                  role="tab"
                  aria-selected={type === t.key}
                  onClick={() => pick(t.key)}
                  title={t.hint}
                  className="text-xs px-3 py-2 font-bold uppercase tracking-wide transition"
                  style={type === t.key ? { backgroundColor: '#c9a84c', color: '#0d1b2e' } : { color: '#9ca3af' }}
                >
                  {t.label}
                </button>
              ))}
            </div>
            <p className="text-xs text-gray-500 mt-2">{current.hint}</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white text-xl leading-none px-2" title="Close">✕</button>
        </div>
        {/* key: switching type starts that report fresh */}
        <Component key={type} embedded onClose={onClose} />
      </div>
    </div>
  );
}
